module.exports = __webpack_public_path__ + "static/arayuz-7362115c2e46f3a3bf5caa20a75159e7.png";